// extracted by mini-css-extract-plugin
export default {"settings-layout__wrapper":"Integration_settings-layout__wrapper__ORmRN","settings-layout__body":"Integration_settings-layout__body__8cZsF"};